(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-section-reviews"] && !window.DesignMode) return;
  try {
    
  const gridSlider= document.querySelector('.reviews--custom grid-slider');
  if(window.theme.touch && gridSlider) {
    window.theme.touch = false;
    gridSlider.init()
    window.theme.touch = true;
  }

  } catch(e) { console.error(e); }
})();
})();
